import { capitalizeFn, sanitizeSubLabelFn } from '../../utils/nodeSelectedDetails';

export const NODE_DETAILS = {
  Conditions: {
    label: 'Check for',
    propertyName: 'conditionProperty',
    transformFn: capitalizeFn,
  },
  Actions: {
    label: 'Action',
    propertyName: 'subLabel',
    transformFn: sanitizeSubLabelFn,
  },
  Triggers: {
    label: 'Trigger',
    propertyName: 'subLabel',
    transformFn: capitalizeFn,
  },

  default: {
    label: 'Action',
    propertyName: 'subLabel',
    transformFn: capitalizeFn,
  },
};

export const MULTIMEDIA_TYPES = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
};

export const CONDITION_LABELS_MAP = {
  'Card Condition': 'Check Card',
  'Intent Condition': 'Check Intent',
  'Payment Condition': 'Check Payment',
};
